<div class="appComponent">
@if (logicInitialized() && languageKey()) {
  <h1>{{ placeTitle }}</h1>
  @for (text of preDesc; track text) {
    <div>
      <p>{{ text }}</p>
    </div>
  }
  <div id="divDescription" [innerHTML]="description | inlineActions:actions"></div>
  @for (text of postDesc; track text) {
    <div>
      <p>{{ text }}</p>
    </div>
  }
  <ul class="action-buttons">
    @for (action of actionButtons; track $index) {
      <li><button (click)="onAction($event, action.place)" [disabled]="!enabled">{{ action.caption }}</button></li>
    } @empty {
      <li><button (click)="restart()">{{ restartCaption() }}</button></li>
    }
  </ul>
  <input #self hidden="hidden" id="message-to-ng" (change)="onAction($event, self.value)"/>
  <div class="statusBar">
    @if (status) {
      <span (mouseover)="showTooltip(status())" (mouseout)="hideTooltip()">{{ _("Status") }}</span>
    }
    <span (mouseover)="showTooltip(_('Double click to restart the adventure'))" (mouseout)="hideTooltip()" (dblclick)="restart()">{{ _("Restart") }}</span>
    @if (closeButton) {
      <span (mouseover)="showTooltip(_('Click to return from the game'))" (mouseout)="hideTooltip()" onclick="window.close()" class="red-button">{{ _("Close") }}</span>
    }
    <div id="tooltip"></div>
  </div>
}
</div>
